<template>
    <div
        class="w-full  gap-5 flex flex-col items-start justify-start pt-2 overflow-hidden"
    >
        <div
            class="flex items-center gap-2 cursor-pointer"
            @click="$emit('close')"
        >
            <icon-container
                class="transform -rotate-90"
                :icon="'SimpleArrowIcon'"
                :iconSize="'5'"
                iconFill="fill-primary"
            />
            <p class="text-primary">Zurück</p>
        </div>
        <div class="w-full relative group" v-if="mediaBase64">
            <pdf-canvas
                :baseString="mediaBase64"
                v-if="mediaBase64"
                ref="pdfCanvas"
                :has-button="false"
            />
        </div>
    </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";
import PdfCanvas from "../course/courseContent/slide/pdf/PdfCanvas.vue";
import IconContainer from "../../components/helper/IconContainer.vue";
export default defineComponent({
    name: "DocumentShow",
    components: { PdfCanvas, IconContainer },
    emits: ["close"],
    props: { mediaBase64: { required: true } },
    setup() {
        return {};
    },
});
</script>
